// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Init accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Match height
         */
        __initMatchHeight: () => {
            const partnerLogos = wntrTheme.body.find('.partner__logo-wrapper');
            if(partnerLogos.length) {
                partnerLogos.matchHeight();
            }
        },

        /**
         * Slick slider
         */
        __initSlickSlider: function() {

            const slider = wntrTheme.body.find('.slideshow__slider');

            const settings = {
                dots: false,
                infinite: false,
                speed: 300,
                swipeToSlide: true,
                slidesToShow: 1,
                prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                responsive: [
                    //{
                    //    breakpoint: 1448,
                    //    settings: {
                    //        slidesToShow: 4,
                    //        arrows: true
                    //    }
                    //},
                    //{
                    //    breakpoint: 1024,
                    //    settings: {
                    //        slidesToShow: 3,
                    //        arrows: false,
                    //    }
                    //},
                    //{
                    //    breakpoint: 720,
                    //    settings: {
                    //        slidesToShow: 2,
                    //        arrows: false,
                    //    }
                    //},
                    //{
                    //    breakpoint: 420,
                    //    settings: {
                    //        slidesToShow: 1.5,
                    //        arrows: false,
                    //    }
                    //},
                ]
            };

            if(slider.length) {
                slider.slick(settings);
            }
        },

        /**
         * Toggle sub menu
         */
        __toggleSubMenu: () => {
            if($(window).width() < 1024) {
                const toggleSubMenuButton = wntrTheme.body.find('.header__toggle-sub-menu');

                toggleSubMenuButton.on('click', function() {
                    const btn = $(this);
                    btn.toggleClass('is--active');
                    btn.closest('.menu-item-has-children').find('.sub-menu').slideToggle('fast');
                });

                const active_sub_menu = wntrTheme.body.find('li.active .sub-menu');
                if(active_sub_menu.length) {
                    active_sub_menu.closest('.menu-item-has-children')
                        .find('.header__toggle-sub-menu')
                        .addClass('is--active');
                    active_sub_menu.css('display', 'block');
                }
            } else {
                const hover_submenu_items = wntrTheme.body.find('.header__navigation li.menu-item-has-children');

                wntrTheme.body.find('.header__toggle-sub-menu').attr('tabindex', '-1');

                hover_submenu_items.on('mouseenter', function() {
                    $(this).addClass('submenu-active');
                });

                hover_submenu_items.on('mouseleave', function() {
                    $(this).removeClass('submenu-active');
                });

                wntrTheme.body.find('li.menu-item-has-children > a').on('focus', function() {
                    $(this).closest('.menu-item-has-children').addClass('submenu-active');
                });

                wntrTheme.body.find('.sub-menu li:last-of-type > a').on('keydown', function(event) {
                    const menuItem = $(this).closest('.menu-item-has-children');
                    if(event.shiftKey && event.keyCode === 9) {
                        menuItem.addClass('submenu-active'); // shift+tab bakåt, stanna kvar
                    } else if(event.keyCode === 9) {
                        menuItem.removeClass('submenu-active'); // tab framåt, stäng meny
                    }
                });
            }
        },

        /**
         * Toggle header
         */
        __toggleHeader: () => {
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');
            const header = wntrTheme.body.find('.header--mobile');
            const main = wntrTheme.body.find('main');

            toggleHeaderButton.on('click', function() {
                if(header.hasClass('mobile-menu-active')) {
                    wntrTheme.body.removeClass('fixed');
                    header.removeClass('mobile-menu-active');
                    main.removeClass('mobile-menu-active');
                    $(this).removeClass('is-active');
                } else {
                    header.addClass('mobile-menu-active');
                    main.addClass('mobile-menu-active');
                    wntrTheme.body.addClass('fixed');
                    $(this).addClass('is-active');
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && header.hasClass('mobile-menu-active')) {
                    header.removeClass('mobile-menu-active');
                    main.removeClass('mobile-menu-active');
                    wntrTheme.body.removeClass('fixed');
                    wntrTheme.body.find('.header__toggle-menu').removeClass('is-active');
                }
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);